// src/data/m3/index.js

import { M3_UNIT_1 } from './Unit1';
import { M3_UNIT_2 } from './Unit2';
import { M3_UNIT_3 } from './Unit3';
import { M3_UNIT_4 } from './Unit4';
import { M3_UNIT_5 } from './Unit5';
import { M3_UNIT_6 } from './Unit6';
import { M3_UNIT_7 } from './Unit7';
import { M3_UNIT_8 } from './Unit8';
import { M3_UNIT_9 } from './Unit9';
import { M3_UNIT_10 } from './Unit10';
import { M3_UNIT_11 } from './Unit11';
import { M3_UNIT_12 } from './Unit12';
import { M3_UNIT_13 } from './Unit13';
import { M3_UNIT_14 } from './Unit14';
import { M3_UNIT_15 } from './Unit15';
import { M3_UNIT_16 } from './Unit16';
import { M3_READING } from './ReadingPractice';
import { M3_REVIEW } from './UnitReview';


export const MODULE_3_UNITS = [
  M3_UNIT_1,
  M3_UNIT_2,
  M3_UNIT_3,
  M3_UNIT_4,
  M3_UNIT_5,
  M3_UNIT_6,
  M3_UNIT_7,
  M3_UNIT_8,
  M3_UNIT_9,
  M3_UNIT_10,
  M3_UNIT_11,
  M3_UNIT_12,
  M3_UNIT_13,
  M3_UNIT_14,
  M3_UNIT_15,
  M3_UNIT_16,
  M3_READING,
  M3_REVIEW,
];